export const applicationNameKey = {
    webWeatherPortal: 'Web Weather Portal',
    mobileWeatherPortal: 'Mobile Weather Portal',
    decisionVue: 'Decision Vue'
};

export const getAppNameKey = (label) => {
    return Object.keys(applicationNameKey).find(
      (key) => applicationNameKey[key] === label
    );
};